'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { PRODUCT_BRANDS, type ProductBrand } from '@/lib/brand/productBrand';

const ProductBrandContext = createContext<ProductBrand>(PRODUCT_BRANDS.engageiq);

export function ProductBrandProvider({ brand, children }: { brand: ProductBrand; children: ReactNode }) {
  return <ProductBrandContext.Provider value={brand}>{children}</ProductBrandContext.Provider>;
}

export function useProductBrand(): ProductBrand {
  return useContext(ProductBrandContext);
}
